import { Navigate, useParams } from 'react-router-dom';

import { useGetProveedor } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveProveedores } from '../../shared/components/saveProveedores';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateProveedorPageInterface {}

const UpdateProveedorPage: React.FC<UpdateProveedorPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_proveedor)

  const { id } = useParams();
  const { data, isLoading } = useGetProveedor(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_proveedor) return <Navigate to="/compras/proveedor" />;

  return (
    <SaveProveedores titlePage="Editar Proveedores" editProveedor={data.data} />
  );
};

export default UpdateProveedorPage;
